import React from 'react';
import './App.css';
import { useNavigate } from 'react-router-dom';
import icon from './images/rosai.jpg';
import rosaf from './images/ROSAF.gif';
import rosas from './images/RosaS.gif';
import rosasc from './images/SC.gif';
import rosap from './images/ROSAP.gif';
import rosai from './images/Rosai.gif';
import rosad from './images/RosaD.png';
import nb from './images/Neobot.jpg';
import rosaaccounting from './images/RosaAc.png';
import rosag from './images/Rosa G Icon.gif';
import CosmoAutomation from './images/CosmoAutomation.jpg';
import RosaChatgpt from './images/ChatgptRosaa.jpg';
import CraftyCounterIcon from './images/CraftyCounter.png';
import VendingMachineIcon from './images/vending-machine-icon.png';

const MainPage = () => {
  const navigate = useNavigate();
  const userEmail = sessionStorage.getItem('userEmail');

  if (!userEmail) {
    navigate('/signin');
    return null;
  }

  const sendButtonInfo = async (buttonName) => {
    try {
      const response = await fetch('https://www.d-rosa.ai/user_folder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          path: `/var/www/myflaskapp/flask_static/${userEmail}`,
          folder_name: buttonName // You can customize the folder name as needed
        
        }),
      });

      if (response.ok) {
        console.log('Data sent successfully');
      } else {
        console.error('Failed to send data');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

 
  const handleNavigate1 = async () => {
    await sendButtonInfo('Rosai');
    navigate('/Rosai');
  }; 

  const handleNavigate2 = async () => {
    await sendButtonInfo('Rosaf');
    navigate('/Rosaf');
  };

const handleNavigate3 = async () => {
    await sendButtonInfo('RosaS');
    navigate('/RosaS');
  };

   const handleNavigate4 = async () => {
    await sendButtonInfo('Rosasc');
    navigate('/RosaSc');
  };

const handleNavigate5 = async () => {
    await sendButtonInfo('Rosap');
    navigate('/Rosap');
  };

const handleNavigate6 = async () => {
    await sendButtonInfo('Rosad');
    navigate('/Rosad');
  };

const handleNavigate7 = async () => {
    await sendButtonInfo('NeoBot');
    navigate('/neobot_pizza');
  };
const handleNavigate8 = async () => {
    await sendButtonInfo('NeoBot');
    navigate('/neobot_truck');
  };

const handleNavigate10 = async () => {
    await sendButtonInfo('NeoBot');
    navigate('/neobot');
  };

const handleNavigate11 = async () => {
    await sendButtonInfo('RosaAc');
    navigate('/RosaAccounting');
  };
const handleNavigate12 = async () => {
    await sendButtonInfo('RosaMkt');
    navigate('/RosaMkt');
  };

const handleNavigate13 = async () => {
    await sendButtonInfo('Rosag');
    navigate('/rosag');
  };


const handleNavigate14 = async () => {
    await sendButtonInfo('CosmoAutomation');
    navigate('/MainCosmo');
  };


const handleNavigate15 = async () => {
    await sendButtonInfo('RosaChatgpt');
    navigate('/RosaChatgpt');
  };


const handleNavigate16 = async () => {
  await sendButtonInfo('CraftCounter');
  navigate('/CraftCounter');
};

 
const handleNavigate17 = async () => {
  await sendButtonInfo('vending-machine');
  navigate('/vending-machine');
};
 

  return (
    <div id="image-container">
      <img id="myimage" src={icon} alt="img" width="80" height="80" />

<center>
  <h2 className="center-heading" style={{ color: 'pink' }}>Main Page</h2><br /><br />
  <p>Signed in as: {userEmail}</p>

<table className="button-table">
  <tbody>
<tr>
<td>
        <button
        onClick={handleNavigate12}
        style={{
          padding: "14px 30px",
          fontSize: "18px",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        Rosa Mkt
      </button>
              </td>
<td>
        <button className="button" onClick={handleNavigate13}>
          <img src={rosag} className="app-img" width="120" height="100" alt="img" />
        </button>
      </td>

</tr>

    <tr>
      <td>
        <button className="button" onClick={handleNavigate8}>
          <img src={nb} className="app-img" width="120" height="100" alt="img" />
        </button>
        <div className="app-label">Truck Bodies</div>
      </td>

      <td>
        <button className="button" onClick={handleNavigate7}>
          <img src={nb} className="app-img" width="120" height="100" alt="img" />
        </button>
        <div className="app-label">Pizza</div>
      </td>
    </tr>

    <tr>
      <td>
        <button className="button" onClick={handleNavigate2}>
          <img src={rosaf} className="app-img" width="120" height="100" alt="img" />
        </button>
      </td>

      <td>
        <button className="button" onClick={handleNavigate3}>
          <img src={rosas} className="app-img" width="120" height="100" alt="img" />
        </button>
      </td>
    </tr>

    <tr>
      <td>
        <button className="button" onClick={handleNavigate4}>
          <img src={rosasc} className="app-img" width="120" height="100" alt="img" />
        </button>
      </td>

      <td>
        <button className="button" onClick={handleNavigate5}>
          <img src={rosap} className="app-img" width="120" height="100" alt="img" />
        </button>
      </td>
    </tr>

    <tr>
      <td>
        <button className="button" onClick={handleNavigate1}>
          <img src={rosai} className="app-img" width="120" height="100" alt="img" />
        </button>
      </td>

      <td>
        <button className="button" onClick={handleNavigate6}>
          <img src={rosad} className="app-img" width="120" height="100" alt="img" />
        </button>
      </td>
    </tr>
 <tr>
      <td>
        <button className="button" onClick={handleNavigate10}>
          <img src={nb} className="app-img" width="120" height="100" alt="img" />
        </button>
        <div className="app-label">Neobot Manufacturing</div>
      </td>


<td>
        <button className="button" onClick={handleNavigate11}>
          <img src={rosaaccounting} className="app-img" width="120" height="100" alt="img" />
        </button>
       
      </td>

</tr>

<tr>

<td>
        <button className="button" onClick={handleNavigate14}>
          <img src={CosmoAutomation} className="app-img" width="120" height="100" alt="img" />
        </button>
       
      </td>

<td>
        <button className="button" onClick={handleNavigate15}>
          <img src={RosaChatgpt} className="app-img" width="120" height="100" alt="img" />
        </button>
       
      </td>


</tr>

<tr>
  <td>
    <button
      className="button"
      onClick={handleNavigate16}
    >
      <img
        src={CraftyCounterIcon}
        className="app-img"
        width="120"
        height="100"
        alt="Craft Counter"
      />
    </button>

    <div className="app-label">
      Craft Counter
    </div>
  </td>

<td>
        
<button
      className="button"
      onClick={handleNavigate17}
    >
      <img
        src={VendingMachineIcon}
        className="app-img"
        width="120"
        height="100"
        alt="Vending Machine"
      />
    </button>

    <div className="app-label">
      Vending Machine
    </div>
      </td>


</tr>


  </tbody>
</table>
</center>
    <br />
    <br />

      <footer className="footer-section">
        <div className="container-4">
          <div className="nav-items"></div>
          <div className="text-6">&copy; 2022 HYDAX Pvt.Ltd. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
}

export default MainPage;
